import block from 'bem-cn-lite';
import React, {FC, ReactNode} from 'react';

import {HTML} from '@doc-tools/components';
import {Col, GridColumnSize} from '@yandex-data-ui/page-constructor';

import {DefaultCategorizedItemSizes, NavigationSectionType} from '../../models';
import {NavigationItemBlockSize} from 'units/constructor-local/models';
import {NavigationItemTypes} from 'units/navigation/components/NavigationItems/NavigationIcon/NavigationIcon';

import './NavigationCategorizedItem.scss';

const b = block('navigation-categorized-item');

interface NavigationCategorizedItemProps {
    id: string;
    url: string;
    title: string;
    size: NavigationItemBlockSize;
    icon?: ReactNode | null;
    type: NavigationSectionType | NavigationItemTypes;
    description?: string | null;
    dataQa?: string;
    colSizes?: Record<GridColumnSize, number>;
    tag?: ReactNode | null;
}

const NavigationCategorizedItem: FC<NavigationCategorizedItemProps> = (props) => {
    const {
        id,
        url,
        title,
        description,
        dataQa,
        colSizes = DefaultCategorizedItemSizes,
        tag,
        size,
        icon,
    } = props;

    return (
        <Col key={id} className={b({size, 'without-icon': !icon})} sizes={colSizes}>
            <a className={b('content')} href={url} data-qa={dataQa && `${dataQa}-preview-link`}>
                {icon}
                <div>
                    <div className={b('title-tag-wrapper')}>
                        <span className={b('title')}>{title}</span>
                        &nbsp;
                        {tag}
                    </div>
                    {description && <HTML className={b('description')}>{description}</HTML>}
                </div>
            </a>
        </Col>
    );
};

export default NavigationCategorizedItem;
